<template>
    <div class="add-basic-information">
        <div class="add-title">
            <span class="basic title-font-style">开票信息</span>
            <div class="save">
              <el-button
              type="primary"
              v-if="(this.$route.path === '/crm/customer/details'||this.$route.path === '/crm/supplier/supplierEdit')&&isEdit"
              @click="onSave">保存</el-button>
              <el-button
              type="primary"
              v-if="(this.$route.path === '/crm/customer/details'||this.$route.path === '/crm/supplier/supplierEdit')&&!isEdit"
              @click="onDetail">编辑</el-button>
            </div>
        </div>
        <div  class="add-content" style='padding-left:50px;padding-bottom:10px;'>
          <el-form :model="queryParams" class="demo-form-inline"  :label-width='!isEdit ? "" : "95px"' ref="queryParams">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="公司名称：">
                  {{queryParams.ciName||'--'}}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="税号：">
                  <span v-if="!isEdit">{{queryParams.ciTaxcode||'--'}}</span>
                  <el-input  v-else v-model="queryParams.ciTaxcode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开票地址：" >
                  <span v-if="!isEdit">{{queryParams.ciTaxaddress||'--'}}</span>
                  <el-input v-else v-model="queryParams.ciTaxaddress"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="银行账号：">
                  <span v-if="!isEdit">{{queryParams.ciBankcode||'--'}}</span>
                  <el-input v-else v-model="queryParams.ciBankcode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开户行：" >
                  <span v-if="!isEdit">{{queryParams.ciBank||'--'}}</span>
                  <el-input v-else v-model="queryParams.ciBank"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开票电话：" >
                  <span v-if="!isEdit">{{queryParams.ciPhone||'--'}}</span>
                  <el-input v-else @input.native="onInput" v-model="queryParams.ciPhone"></el-input>
                </el-form-item>
              </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="收票人：">
                    <span v-if="!isEdit">{{queryParams.ciRecevier||'--'}}</span>
                    <el-input v-else v-model="queryParams.ciRecevier"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="联系电话：">
                    <span v-if="!isEdit">{{queryParams.ciRecevierPhone||'--'}}</span>
                    <el-input @input.native="onInput" v-else v-model="queryParams.ciRecevierPhone"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="16">
                  <el-form-item label="收票地址：">
                    <span v-if="!isEdit">{{queryParams.ciRecevierProvince||'--'}}</span>
                    <el-address v-else
                    :provinceEdit="provinceBilling"
                    :city="cityBilling"
                    :district="districtBilling"
                    @changAddress="changAddress"></el-address>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="详细地址：">
                    <span v-if="!isEdit">{{queryParams.ciRecevierAddress||'--'}}</span>
                    <el-input v-else v-model="queryParams.ciRecevierAddress"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
          </el-form>
        </div>
    </div>
</template>
<script>
import address from '@/components/Address/index'
import { updateCustomerInvoice } from '@/api/customer/customerManage'
import { supplierInvoiceUpdateById } from '@/api/supplier/supplierManage'
export default {
  components: {
    'el-address': address
  },
  props: ['isShow', 'billingInformation', 'ciTaxcode', 'ciName'],
  data () {
    return {
      queryParams: {
        ciRecevierProvince: '',
        ciRecevierProcode: '',
        ciTaxcode: '',
        ciTaxaddress: '',
        ciBank: '',
        ciBankcode: '',
        ciPhone: '',
        ciRecevier: '',
        ciRecevierPhone: '',
        ciRecevierAddress: '',
        suId: '',
        // ciTaxcode: '',
        ciName: '' // 公司名称
      },
      provinceBilling: {}, // 开票省
      cityBilling: {}, // 开票市
      districtBilling: {}, // 开票区/县
      isEdit: false
    }
  },
  watch: {
    billingInformation (val, oldVal) {
      if (this.$route.path === '/crm/supplier/supplierEdit') { // 供应商开票信息参数转换
        this.queryParams.uncid = this.billingInformation.uncid
        this.queryParams.ciTaxcode = this.billingInformation.suTaxcode
        this.queryParams.ciTaxaddress = this.billingInformation.suTaxaddress
        this.queryParams.ciBank = this.billingInformation.suBank
        this.queryParams.ciBankcode = this.billingInformation.suBankcode
        this.queryParams.ciPhone = this.billingInformation.suTaxphone
        this.queryParams.ciRecevier = this.billingInformation.suConnname
        this.queryParams.ciRecevierPhone = this.billingInformation.suConnphone
        this.queryParams.ciRecevierProvince = this.billingInformation.suProvince
        this.queryParams.ciRecevierProcode = this.billingInformation.suProcode
        this.queryParams.ciRecevierAddress = this.billingInformation.suAddress
        this.queryParams.id = this.billingInformation.id
        this.queryParams.suId = this.billingInformation.suId
        this.queryParams.ciName = this.billingInformation.suName
      } else if (this.$route.path === '/crm/customer/details') { // 客户管理开票信息
        this.queryParams = this.billingInformation
      }
    },
    ciTaxcode: 'ciTaxcodeChange',
    ciName: 'nameChange'
  },
  mounted () {
    this.isEdit = this.isShow
  },
  methods: {
    onInput(e) {
      // 过滤非数字和符号
      const regName = /^[\d-]+$/
      if (!regName.test(e.target.value)) {
        e.target.value = ''
      } else {
        return true
      }
    },
    ciTaxcodeChange () {
      this.queryParams.ciTaxcode = this.ciTaxcode
    },
    // 公司名称和客户名称联动
    nameChange () {
      this.queryParams.ciName = this.ciName
    },
    // 通过省id获取市级
    changAddress (params) {
      this.queryParams.ciRecevierProvince = params.name
      this.queryParams.ciRecevierProcode = params.code
    },
    // 编辑
    async onDetail () {
      this.isEdit = true
      if (this.queryParams.ciRecevierProcode !== null && this.queryParams.ciRecevierProvince !== null) {
        const bizParams = await this.$analysisAddress(this.queryParams.ciRecevierProcode, this.queryParams.ciRecevierProvince)
        this.provinceBilling = bizParams.province
        this.cityBilling = bizParams.city
        this.districtBilling = bizParams.district
      }
    },
    // 保存
    onSave () {
      if (this.$route.path === '/crm/customer/details') {
        if (this.queryParams.id === null) {
          delete this.queryParams.id
        } // 客户管理开票信息保存
        updateCustomerInvoice(this.queryParams).then(res => {
          if (res.data.code === 200) {
            this.$message.success('保存成功!')
            this.isEdit = false
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      } else if (this.$route.path === '/crm/supplier/supplierEdit') { // 供应商开票信息保存
        const supplierOpenIn = { // 开票
          suProvince: this.queryParams.ciRecevierProvince,
          suProcode: this.queryParams.ciRecevierProcode,
          suName: this.queryParams.ciName,
          suTaxcode: this.queryParams.ciTaxcode,
          suTaxaddress: this.queryParams.ciTaxaddress,
          suBank: this.queryParams.ciBank,
          suBankcode: this.queryParams.ciBankcode,
          suTaxphone: this.queryParams.ciPhone,
          suConnname: this.queryParams.ciRecevier,
          suConnphone: this.queryParams.ciRecevierPhone,
          suAddress: this.queryParams.ciRecevierAddress,
          id: this.queryParams.id,
          suId: this.queryParams.suId
        }
        supplierInvoiceUpdateById(supplierOpenIn).then(res => {
          if (res.data.code === 200) {
            this.$message.success('保存成功!')
            this.isEdit = false
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
